<!--
 * @Description: 首页 常规工作/日常事务 资料汇编
 * @Author: PF
 * @Date: 2023-01-05 09:27:56
 * @LastEditors: PF
 * @LastEditTime: 2024-10-11 09:10:04
-->

<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">资料汇编</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container class="hp100">
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-input placeholder="标题" class="filter-item" v-model="dataGrid.parms.cfwzmc" clearable @clear="initLeftList()" @keyup.enter="initLeftList()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-cascader placeholder="发布机构" :options="jgData" clearable filterable  v-model="dataGrid.parms.jgid" :show-all-levels="false" :props="{ label: 'jgmc', value: 'id', children: 'children', checkStrictly: true}" change-on-select @change="bindTable()">
                </el-cascader>
              </el-form-item>
              <el-form-item>
                <el-select placeholder="资料分类" v-model="dataGrid.parms.zlflid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in zlflData" :key="item.id" :label="item.zlflbt" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="标题" prop="bt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span style="color: #409EFF;cursor: pointer;" @click="openZlDetail=true;tcrow=scope.row">{{ scope.row.bt }}</span>
                </template>
              </el-table-column>
              <el-table-column label="发布机构" prop="jgmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="发布人" prop="fbrmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="发布时间" prop="fbsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <ziliaohuibiandetail v-if="openZlDetail" v-model:openDetail="openZlDetail" :row="tcrow" />
</template>

<script setup>
import { ref, watch, defineProps } from 'vue'
// 分页
import pagination from '@/components/pagination.vue'
import { loadList, homeCloseWindow, loadSelect } from '@/api/common.js'
import { loadXiaoQuJiGouCascader } from '@/api/queryJiGou.js'
import ziliaohuibiandetail from '@/pages/bangong/richangbangong/ziliaohuibian/detail.vue' // 资料汇编详情

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'fbsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.jgid = Array.isArray(dataGrid.value.parms.jgid) ? dataGrid.value.parms.jgid[dataGrid.value.parms.jgid.length - 1] : dataGrid.value.parms.jgid
  loadList({
    url: '/api/v2/bangong/ziliaohuibian/shenhetongguopagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const tcrow = ref()
const openList = ref(false)
const openZlDetail = ref(false)

// 加载 开设机构 下拉框
const jgData = ref()

// 加载 资料分类 下拉框
const zlflData = ref([])
watch(
  () => props.open,
  () => {
    if (props.open === 'ziliaohuibian') {
      openList.value = true
      loadXiaoQuJiGouCascader(jgData)
      loadSelect({ url: '/api/v2/bangong/ziliaohuibianziliaofenlei/list', data: zlflData, order: 'zlflbt', sort: 'asc' })
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
